export default "__VITE_ASSET__DJfTkx$I__"